import { useEffect, useState } from "react";
import { Film } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";

export const SupporterBadge = ({ hint = false }) => {
  const [supporter, setSupporter] = useState(null);
  useEffect(() => { api.get("/supporter").then(({ data }) => setSupporter(data.supporter)).catch(() => setSupporter(false)); }, []);
  if (supporter === null) return null;
  if (supporter) return (
    <span className="flex items-center gap-1.5 border-2 border-[#DC2626] bg-[#7f1d1d]/30 px-2 py-1 font-blocky text-[8px] sm:text-[9px] text-[#F3F4F6] tracking-wider whitespace-nowrap shadow-[0_0_12px_rgba(220,38,38,0.35)]"
      title="Thank you for helping make the Gods We Call feature film" data-testid="film-supporter-badge">
      <Film size={12} className="text-[#DC2626]" /> FILM SUPPORTER
    </span>
  );
  if (!hint) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="flex items-center gap-1.5 border border-dashed border-[#2E3440] hover:border-[#64748B] px-2 py-1 pixel-text text-base text-[#64748B] hover:text-[#9CA3AF] transition-colors whitespace-nowrap" data-testid="film-supporter-hint">
          <Film size={12} /> <span className="hidden sm:inline">Become a Film Supporter</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="bg-[#0A0B10] border-2 border-[#7f1d1d] rounded-none w-72 pixel-text text-lg text-[#9CA3AF] leading-snug" data-testid="film-supporter-hint-info">
        <p className="font-blocky text-[9px] text-[#DC2626] mb-2">FILM SUPPORTER</p>
        Buy any chapter, or pre-order the next one, to earn the Film Supporter badge. Every purchase helps make the Gods We Call feature film.
      </PopoverContent>
    </Popover>
  );
};
